export type ToggleObisRecord = {
  'BLOCK LOAD BY DATETIME': string;
  'DAILY LOAD BY DATETIME': string;
  'PROFILE INSTANT': string;
  'BILLING BY INDEX': string;
  'ALL EVENT PULL': string;
  'NAME PLATE DETAIL': string;
  'US SET RTC': string;
  'US SET DEMAND INTEGRATION PERIOD': string;
  'US SET PROFILE CAPTURE PERIOD': string;
  'SET BILLING ACTION SCHEDULE': string;
  'SET TOU PASSIVE DAY PROFILE': string;
  'US SET IPV6 EVENT PUSH': string;
  'US SET IMAGE ACTIVATION TS': string;
  'US SET METERING MODE': string;
  'SET LLS KEY': string;
  'SET HLS KEY': string;
  'SET HLS FW KEY': string;
  'US SET ESW FILTER': string;
  'US ACTION MDI RESET': string;
};

export const toggleObis: ToggleObisRecord = {
  'BLOCK LOAD BY DATETIME': '1.0.99.1.0.255',
  'DAILY LOAD BY DATETIME': '1.0.99.2.0.255',
  'PROFILE INSTANT': '1.0.94.91.0.255',
  'BILLING BY INDEX': '1.0.98.1.0.255',
  'ALL EVENT PULL': '0.0.96.11.e.255',
  'NAME PLATE DETAIL': '0.0.94.91.10.255',
  'US SET RTC': '0.0.1.0.0.255',
  'US SET DEMAND INTEGRATION PERIOD': '1.0.0.8.0.255',
  'US SET PROFILE CAPTURE PERIOD': '1.0.0.8.4.255',
  'SET BILLING ACTION SCHEDULE': '0.0.15.0.0.255',
  'SET TOU PASSIVE DAY PROFILE': '0.0.13.0.0.255',
  'US SET IPV6 EVENT PUSH': '0.0.22.0.0.255',
  'US SET IMAGE ACTIVATION TS': '0.0.44.0.0.255',
  'US SET METERING MODE': '0.0.94.96.19.255',
  'SET LLS KEY': '0.0.40.0.2.255',
  'SET HLS KEY': '0.0.40.0.3.255',
  'SET HLS FW KEY': '0.0.40.0.5.255',
  'US SET ESW FILTER': '0.0.94.91.26.255',
  'US ACTION MDI RESET': '0.0.10.0.1.255'
};

export const allowedCommandsForOBISDownload = [
  'BLOCK LOAD BY DATETIME',
  'DAILY LOAD BY DATETIME',
  'NAME PLATE DETAIL',
  'PROFILE INSTANT',
  'BILLING BY INDEX',
  'ALL EVENT PULL',
  'GET POWER EVENT PROFILE',
  'GET TRANSACTION EVENT PROFILE',
  'GET CURRENT EVENT PROFILE',
  'GET NON ROLL OVER EVENT PROFILE',
  'GET OTHER EVENT PROFILE',
  'GET VOLTAGE EVENT PROFILE',
  'GET DIGITAL INPUT EVENT',
  'GET CONTROL EVENT PROFILE'
];
